import { useTranslation } from "react-i18next";

export function useConnectionHelpPanelText() {
  const { t } = useTranslation();
  return {
    closeAriaLabel: t("board.connections.help.closeAriaLabel"),
    fallbackTitle: t("board.connections.help.fallbackTitle"),
    fallbackBody: t("board.connections.help.fallbackBody"),
    fullDocumentationLink: t("board.connections.help.fullDocumentationLink"),
  };
}
